module.exports = __webpack_public_path__ + "c_static/img/2-4电脑天猫购物车.c8e75be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/4-回购特卖入口/2-4电脑天猫购物车.jpg
// module id = 4jtj
// module chunks = 33